module.exports = __webpack_public_path__ + "media/DarkLogo.57ec52a7.svg";